export default __webpack_public_path__ + "static/media/minibar.2e032b37.png";